import { lhbRecordsList } from "constants/lhbRecords";
import { timesheetLhbRecords } from "constants/timesheet";

const initialState = {
  timesheetLhbRecords: {},
  lhbRecordsList: {},
};

const timesheet = (state = initialState, action) => {
  switch (action.type) {
    case timesheetLhbRecords:
      return { ...state, timesheetLhbRecords: action.payload };

    case lhbRecordsList:
      return { ...state, lhbRecordsList: action.payload };

    default:
      return state;
  }
};
export default timesheet;
